import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { twMerge } from 'tailwind-merge';
import { faComment } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';

type Props = {
  className?: string;
  onClick: () => void;
  iconSize: number;
} & ({ variant: 'post'; commentCount: number | null } | { variant: 'comment' });

export function CommentButton(props: Props) {
  const { className, onClick, variant, iconSize } = props;
  return (
    <button
      className={twMerge(
        'cursor-pointer rounded-md px-2 py-1 text-base-m hover:bg-neutral100 active:scale-95 ',
        className,
      )}
      onClick={onClick}
    >
      <div className="flex items-center gap-1">
        <FontAwesomeIcon icon={faComment} className="text-neutral500" fontSize={iconSize} />
        {variant === 'comment' ? (
          <span className="font-base font-medium text-neutral500">Reply</span>
        ) : (
          props.commentCount != null && (
            <span className="font-base font-medium text-neutral500">{props.commentCount}</span>
          )
        )}
      </div>
    </button>
  );
}
